import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerGroupBuyPhoneErrorListListDataApi(data) {
  return request({
    url: "web/appConsumerGroupBuyPhoneErrorList/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerGroupBuyPhoneErrorListExportDataApi(data) {
  return request({
    url: "web/appConsumerGroupBuyPhoneErrorList/exportData",
    method: "post",
    data
  });
}